export default __webpack_public_path__ + "static/media/icon_metamask.6ad07203.png";